// Reine Entscheidungslogik für Reconnect — von DO + Client importiert, voll unit-getestet.

export type HelloClassification = 'resume' | 'restore-admit' | 'fresh-waiting' | 'reject';

/**
 * Wie soll die DO ein eingehendes HELLO behandeln? (Set-Semantik, Cap 2 host-seitig egal.)
 * - resume:        live-Speaker ist schon im admitted-Set (Grace) → RESUMED, Slot behalten.
 * - restore-admit: live-Speaker, noch ein Slot frei (frische DO nach Neustart) → ins Set, RESUMED.
 * - reject:        live-Claim, aber kein Slot mehr frei → live-Claim verweigern.
 * - fresh-waiting: nicht live → normaler Wartender.
 */
export function classifyHello(alreadyAdmitted: boolean, slotAvailable: boolean, live: boolean): HelloClassification {
  if (!live) return 'fresh-waiting';
  if (alreadyAdmitted) return 'resume';
  if (slotAvailable) return 'restore-admit';
  return 'reject';
}

const BACKOFF_BASE_MS = 500;
const BACKOFF_CAP_MS = 5000;

/** Exponentielles Backoff für WS-Reconnect-Versuche; bei cap gedeckelt. */
export function backoffMs(attempt: number): number {
  return Math.min(BACKOFF_CAP_MS, BACKOFF_BASE_MS * 2 ** attempt);
}

/** DO-seitiges Reconnect-Fenster (Speaker-Slot-Grace, Host-Grace). */
export const RECONNECT_WINDOW_MS = 30_000;

/**
 * Lock-Grace: Wie lange die Signaling-DO den D1-Live-Lock eines Studios nach Host-Abwesenheit
 * hält, bevor sie ihn freigibt (damit ein anderes Studio den Kundenraum übernehmen kann).
 * Länger als RECONNECT_WINDOW_MS (Admitted-Reset), damit ein kurzer Studio-Netzausfall den
 * Raum NICHT verliert. Kommt der Host innerhalb des Fensters zurück, wird der Timer gecancelt.
 */
export const HOST_LOCK_GRACE_MS = 60_000;

/**
 * Wie lange Speaker (Give-up) + Studio (Backstop) auf eine Wiederkehr warten, bevor
 * endgültig finalisiert wird. Großzügig, weil der Sprecher den Tab im Normalfall in den
 * Hintergrund schiebt (Skript in Word o.ä.) → der Browser drosselt Main-Thread/Timer →
 * Reconnect dauert länger. Der Encoder läuft auf dem Audio-Thread weiter (nie gedrosselt),
 * also bleibt das Backup lückenlos; das Studio nimmt den zurückkehrenden Speaker
 * automatisch wieder an (Resync heilt die Lücke).
 */
export const GIVEUP_WINDOW_MS = 120_000;
